var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRsvUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.2327C17.6514 22.2327 22.2327 17.6514 22.2327 12.0001C22.2327 6.34885 17.6514 1.76758 12.0001 1.76758C6.34885 1.76758 1.76758 6.34885 1.76758 12.0001C1.76758 17.6514 6.34885 22.2327 12.0001 22.2327Z",
    fill: "#00BF9D",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3872 16.7121C17.3872 14.3612 15.7397 12.4497 13.7137 12.4497H10.2858C8.25975 12.4497 6.6123 14.3612 6.6123 16.7121",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3872 16.7121C17.3872 14.3612 15.7397 12.4497 13.7137 12.4497H10.2858C8.25975 12.4497 6.6123 14.3612 6.6123 16.7121H17.3872Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 12.1041C13.5695 12.1041 14.8424 10.8312 14.8424 9.26103C14.8424 7.69085 13.5695 6.41797 11.9993 6.41797C10.4291 6.41797 9.15625 7.69085 9.15625 9.26103C9.15625 10.8312 10.4291 12.1041 11.9993 12.1041Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRsvUser);
export default __webpack_public_path__ + "static/media/ic_rsv_user.d2ac08c00aa1e482e44011335418894f.svg";
export { ForwardRef as ReactComponent };